import { IConfiguration, IUserRestrictionCodesConfiguration, IUserRestrictionConfiguration, RestrictionType } from "../../domain/configuration";
import { IUserRestrictionService, User } from "../../domain/user";

export class UserRestrictionService implements IUserRestrictionService {
  constructor(private readonly _getConfiguration: () => IConfiguration, private readonly _getUser: () => User) {}

  public isRestricted(type: RestrictionType): boolean {
    const configuration = this._getConfiguration();
    const user = this._getUser();
    if (!configuration || !user) {
      return true;  // 設定/ログインユーザが取れない場合は判断できないので制約扱い.
    }
    const restriction = configuration.restriction.user[type];
    if (!restriction || !restriction.isEnable) {
      return false; // 設定が無効.未制約を返す.
    }
    return !this.isAllowed(user, restriction);
  }

  private isAllowed(user: User, restriction: IUserRestrictionConfiguration): boolean {
    // そもそも制約されてない、もしくはどれかが許可されていれば、許可扱い.
    return (!restriction.user.isEnable && !restriction.profession.isEnable)
        || this.isCodeAllowed(user.id, restriction.user)
        || this.isCodeAllowed(user.profession ? user.profession.id : undefined, restriction.profession);
  }

  private isCodeAllowed(code: string, restriction: IUserRestrictionCodesConfiguration): boolean {
    return restriction.isEnable
        && code
        && restriction.allowed.includes(code);
  }
}
